import imagesLoaded from "../../../../_snowpack/pkg/imagesloaded.js";

export function preloadImages(selector) {
	return new Promise((resolve, reject) => {
		imagesLoaded(selector, { background: true }, resolve);
	});
}
